import * as React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  formatBrazilianCurrencyValue,
  formatCurrencyInput,
  parseBrazilianCurrency,
} from "@/utils/formatters";

/**
 * Mesmo comportamento do campo de valores na aba "Gerar Nova Proposta" de Carregadores Veiculares
 * (e no kit manual Dimensionamento → Etapa 3): dígitos entram como centavos, máscara pt-BR.
 */
export function CarregadoresMoneyInput({
  id,
  label,
  value,
  onValueChange,
  helperText,
  disabled,
  readOnly,
  className,
}: {
  id: string;
  label: React.ReactNode;
  value: number;
  onValueChange: (n: number) => void;
  helperText?: React.ReactNode;
  disabled?: boolean;
  readOnly?: boolean;
  className?: string;
}) {
  const safe = Number.isFinite(value) ? value : 0;
  const displayValue = readOnly
    ? formatBrazilianCurrencyValue(safe)
    : safe === 0
      ? ""
      : formatBrazilianCurrencyValue(safe);

  return (
    <div className={className ?? "space-y-2"}>
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        type="text"
        inputMode="numeric"
        autoComplete="off"
        placeholder="0,00"
        disabled={disabled}
        readOnly={readOnly}
        value={displayValue}
        onChange={
          readOnly
            ? undefined
            : (e) => {
                const formatted = formatCurrencyInput(e.target.value);
                const n = parseBrazilianCurrency(formatted);
                onValueChange(n);
              }
        }
        onKeyDown={
          readOnly || disabled
            ? undefined
            : (e) => {
                const allowedKeys = [
                  "Backspace",
                  "Delete",
                  "Tab",
                  "Enter",
                  "ArrowLeft",
                  "ArrowRight",
                  "Home",
                  "End",
                ];
                if (allowedKeys.includes(e.key) || /^\d$/.test(e.key)) {
                  return;
                }
                e.preventDefault();
              }
        }
      />
      {helperText ? <div className="text-xs text-muted-foreground">{helperText}</div> : null}
    </div>
  );
}
